module.exports = __webpack_public_path__ + "img/jjjbzx.a3c05122.jpg";